<template>
  <magic-ui-container
    v-if="initialized"
    v-report.pv="config.report && config.report.pv || config.title"
    class="magic-ui-page"
    :config="pageConfig"
  >
    <div
      v-if="
        !inMagic
          && config.style.backgroundCrop > 0
          && config.style.backgroundParts
          && config.style.backgroundParts.length
      "
      slot="pre"
      class="magic-ui-page-img-wrapper"
    >
      <img
        id="bg_img_cps_part"
        :src="config.style.backgroundParts[0]"
        width="100%"
        style="display: block;"
        @load="loadHandler"
      >
      <img
        :src="bgPart2"
        width="100%"
        style="display:block"
      >
    </div>
    <template v-for="comp in Array.from(dComps)">
      <component
        :is="comp"
        v-if="typeof comp === 'string'"
        :key="comp"
        :ref="comp"
      />
      <component
        v-bind="comp.props"
        :is="comp.name"
        v-else-if="typeof comp.name === 'string'"
        :key="comp.name"
        :ref="comp.name"
      />
    </template>
  </magic-ui-container>
</template>

<script>
import { processPageRender } from '../../../src/mixins/renderView';
export default {
  name: 'MagicUiPage',

  inject: {
    app: {
      default: {},
    },
  },

  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      st: new Date().getTime(),
      rmLoadReport: false,
      initialized: false,
      pageConfig: {},
      shareConfig: null,
      serverTime: new Date().getTime(),
      dComps: new Set(),
      bgPart2: '',
      inMagic: this.inMagic,
    };
  },

  watch: {
    config: {
      deep: true,
      handler() {
        this.initConfig();
      },
    },
  },

  magicTriggerEvents: [
    { label: '页面右上角分享成功', value: 'magic:component:page:browser-shared' },
    { label: '在微信打开', value: 'magic:component:page:env:wx' },
    { label: '[需联动组件支持]首屏底图加载完成', value: 'first-screen-image-loaded' },
    { label: '[需联动组件支持]页面关闭通知', value: 'window-close' },
  ],

  magicCallerMethods: [
    { label: '更新会员信息', value: 'getPayVip' },
    // closeCurrentPage 方法定义在page项目里，vue.prototype
    { label: '关闭当前页面', value: 'closeCurrentPage' },
  ],

  async created() {
    processPageRender(this);

    if (!this.inHippy && !this.inMagic) {
      if (this.app.env.isWeb) {
        if (this.config.pageType !== 'PC' && this.config.webUrl) {
          return window.location.href = this.config.webUrl;
        }
      } else if (this.config.pageType === 'PC' && this.config.h5Url) {
        return window.location.href = this.config.h5Url;
      }
    }

    // 在微信打开触发事件
    if (this.app?.env?.isWechat) {
      this.$bus.$emit('magic:component:page:env:wx', this);
    }

    if (!this.config.created) {
      this.initialized = true;
    } else if (typeof this.config.created === 'function') {
      // 包装 Promise 避免配置的 created 函数非 async 函数时，执行 then 会报错
      Promise.resolve(this.config.created.call(this, this, this.app)).then(() => {
        this.initialized = true;
      });
    }

    this.app.addPage(this);

    this.initConfig();

    this.app.$emit('page-created', this);
    this.$bus.$emit('page-created', this);
  },

  async mounted() {
    if (typeof this.config.mounted === 'function') {
      await this.config.mounted(this);
    }

    this.app.$emit('page-mounted', this);

    setTimeout(() => {
      if (!this.inHippy && !this.inMagic) {
        this.removeNReport();
      }
    }, 2000);
  },

  destroyed() {
    if (this.config.name) {
      this.app.removePage(this);
    }
  },

  methods: {
    isBackgroundCroped(style) {
      if (style.backgroundCrop > 0 && style?.backgroundParts?.length > 0) {
        return true;
      }
      return false;
    },
    initConfig() {
      const { style } = this.config;
      const isBackgroundCroped = this.isBackgroundCroped(style);

      if (!this.inHippy && !this.inMagic) {
        // 背景图无切割时，无模糊图兜底，先移除遮罩层
        if (!isBackgroundCroped) {
          this.removeNReport();
          // 抛出首屏图片已加载的事件
          console.log('first-screen-image-loaded');
          this.$bus.$emit('first-screen-image-loaded', this);
        } else {
          // 如果有切割且模糊背景图存在，如果模糊图不存在（认为在 server 被删除并已经插入 html，背景图设为空）
          style.backgroundImage = style.backgroundParts?.[2] ? `url(data:image/jpeg;base64,${style.backgroundParts[2]})` : '';
        }
      }

      const pageReportModule = `${this.config.report?.pv || this.config.title}_${this.config.id}`;
      this.pageConfig = {
        id: this.config.id,
        className: this.config.className,
        style: this.config.style,
        items: this.config.items,
        html: this.config.html,
        report: {
          module: {
            _module: pageReportModule,
            comp_type: 'page',
          },
        },
      };

      this.app.$emit('page-init-config', this.config);
    },

    // 删除 loading 遮罩
    removeLoader() {
      if (!this.inHippy) {
        const el = window.document.getElementById('m_page_loading_div');
        if (!el) {
          return;
        }
        if (el.remove) {
          el.remove();
        } else {
          el.style.display = 'none';
        }
      }
    },

    // 有模糊背景图时，删除 loader 同时上报删除 laoder 的耗时
    removeNReport() {
      if (this.rmLoadReport) {
        return this.rmLoadReport;
      }
      this.removeLoader();
      return true;
    },

    loadHandler() {
      if (!this.inHippy) {
        this.removeNReport();
      }

      [, this.bgPart2] = this.config.style.backgroundParts;
      // 抛出首屏图片已加载的事件

      this.$bus.$emit('first-screen-image-loaded', this);
    },
  },
};
</script>

<style lang="scss">
.magic-ui-page {
  position: relative;

  .magic-ui-page-img-wrapper {
    position: absolute;
    flex: 1;
    overflow: hidden;
    top: 0;
    width: 100%;
  }

  ._horizontal-center {
    left: 0 !important;
    right: 0 !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  ._vertical-center {
    top: 50% !important;
    transform: translate3d(0, -50%, 0) !important;
  }
}
</style>
